module.exports = __webpack_public_path__ + "static/media/023_v2_account_profile_with_error_status.f02ed387.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/docker/023_v2_account_profile_with_error_status.png
// module id = 402
// module chunks = 0